"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PROMO_BANNER_LEGACY_VIDEO = exports.PROMO_BANNER_LEGACY_TITLE = exports.PROMO_BANNER_LEGACY_IMAGE = exports.PROMO_BANNER_LEGACY_FAKE_LINK = exports.PROMO_BANNER_LEGACY = void 0;
// Test IDs
const PROMO_BANNER_LEGACY = exports.PROMO_BANNER_LEGACY = 'promo-banner-legacy';
const PROMO_BANNER_LEGACY_TITLE = exports.PROMO_BANNER_LEGACY_TITLE = 'promo-banner-legacy-title';
const PROMO_BANNER_LEGACY_FAKE_LINK = exports.PROMO_BANNER_LEGACY_FAKE_LINK = 'promo-banner-legacy-fake-link';
const PROMO_BANNER_LEGACY_IMAGE = exports.PROMO_BANNER_LEGACY_IMAGE = 'promo-banner-legacy-image';
const PROMO_BANNER_LEGACY_VIDEO = exports.PROMO_BANNER_LEGACY_VIDEO = 'promo-banner-legacy-video';
